export default __webpack_public_path__ + "static/media/demo-gamecard.be9e21e6.svg";